import { render, staticRenderFns } from "./top-navigation.vue?vue&type=template&id=5270c732&"
import script from "./top-navigation.ts?vue&type=script&lang=js&"
export * from "./top-navigation.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports